import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseChartDirective, Label, Color } from 'ng2-charts';
import { ChartOptions, ChartType, ChartDataSets, Chart } from 'chart.js';
import { NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'authorization-counters-chart',
  templateUrl: './authorization-counters-chart.component.html',
  styleUrls: ['./authorization-counters-chart.component.css']
})
export class AuthorizationCountersChartComponent implements OnInit {

  @Input()
  public dateChartLabels: any[] = [];

  @Input()
  public allAuthscountChartData: any[] = [];

  @Input()
  public userAuthsChartData: any[] = [];

  @Input()
  public loadingChartData: boolean;

  @Input()
  public changeTypeChart: ChartType;

  public spinner: boolean;
  public containsAccessData: boolean;
  public chartType: ChartType = 'bar';
  public chartPlugins = [];
  public lineChartColors:Array<any> = [
    {
      backgroundColor: 'rgba(176,196,222)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    {
      backgroundColor: 'rgba(255,182,193)',
      //borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
  ]
  public chartOptions: ChartOptions = {
    responsive: true,
    title: {
      display: false,
      text: 'Cadastros realizados',
      fontColor: 'black',
      fontSize: 22
    },
    scales: {
      xAxes: [{
        stacked: false,
        ticks: {
          fontColor: 'black',
        },
        gridLines: {
          color: '#ffffff'
        }
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          fontColor: 'black',
          min: 0,
          beginAtZero: false,
          precision: 0
        },
        gridLines: {
          color: '#ffffff'
        },
        scaleLabel: {
          display: false,
          labelString: 'Scale Label',
          fontColor: 'black',
        }
      }]
    },
    legend: {
      display: true,
      labels: {
        fontColor: 'black'
      }
    },
  };

  public chartData: ChartDataSets[] = [
    { data: [], label: ''},
    { data: [], label: ''},
  ];
  public chartLabels: Label[] = [];

  @ViewChild(BaseChartDirective)
  public chart: any;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  ngOnChanges(){
    this.chartData[0].label = this.translate.instant("DASHBOARD.PAGE.AUTHORIZATION_COUNTER.MY_REGISTERED");
    this.chartData[1].label = this.translate.instant("DASHBOARD.PAGE.AUTHORIZATION_COUNTER.ALL_REGISTRATIONS");
    this.chartData[0].data = this.userAuthsChartData
    this.chartData[1].data = this.allAuthscountChartData;
    this.chartLabels = this.dateChartLabels
    this.chartType = this.changeTypeChart;
    this.spinner = this.loadingChartData;
    
    if(this.allAuthscountChartData.length != 0){
      this.containsAccessData = true;
    }else{
      this.containsAccessData = false;
    }
  }
}
